import { createStore } from 'vuex'  
  
const store = createStore({  
  state: {  

	load_path_no:{},
	login_socket_get:1, // wss 是否执行
	EditorBootOff:true,

    isMobile:false,
    user_times:0,

    user:0,
    token:0,
	port:1,
	send:{},
	nav:0,
	
	rank:0,
	rankKey:0,
	rankBut:{},

	nav_scene_data:'',

    count: 0,

	requestCou:0, // 请求次数

	mianPageCou:0, // 第几次调用
  },  
  mutations: {  
    // 修改信息
		setState(state,result) {
			state[result.key] = result.value
		},

		getState(state, option) {
			// 键名
			const key = option.key
			// 结果
			const value = option.value

			// 更新对象
			state[key] = value
		},
  }  
})

export default store
